import React from 'react';

import { useFormikContext } from 'formik';

import Signature from 'components/shared/Signature/Signature';
import Typography from 'components/shared/Typography/Typography';

const PatientSignature = () => {
  const formik = useFormikContext();

  const handleChange = (value) => {
    formik.setFieldValue('signature', value || '');
  };

  return (
    <div className="flex flex-col gap-1">
      <Typography variant="label" size="medium" weight="medium" htmlFor="signature" required>
        Cardholder signature
      </Typography>
      <Signature
        value={formik.values.signature || null}
        onChange={handleChange}
        canvasHeight={140}
        data-qa="signature-Input completed=false"
      />
      {formik.errors.signature && (
        <Typography variant="p" size="xs" color="danger-500">
          {formik.errors.signature}
        </Typography>
      )}
    </div>
  );
};

export default PatientSignature;
